import React, { useEffect } from "react"
import "react-datepicker/dist/react-datepicker.css"
import { Loading } from "components/ui"

export default function BoxTimeLive({ fetch }) {
  useEffect(() => {
    // eslint-disable-next-line prettier/prettier
  }, [])

  return (
    <div className="flex h-full w-full item-center p-6 gap-6 bg-ranking rounded-2xl">
      <Loading>
        <div className="rounded-lg ">
          <div className=" flex items-center pt-5 pl-14 justify-start">
            <span>
              <img
                src={"https://stvinaprod.vtvcab.vn/fa7fe61b-7b35-4607-9950-6df6538cf7a2.png"}
                alt=""
                width="32"
                height="32"
              ></img>
            </span>
            <span className="font-semibold text-xl text-primary-100 pl-4">{"Hướng dẫn chơi"}</span>
          </div>

          <div className="pt-4 pl-16 pr-14">
            <div className="leading-6 font-bold text-sm text-primary-300">
              Bước 1: Cài Ứng dụng On+
              <span className="block font-normal leading-6 ">
                Vào kho ứng dụng của điện thoại thông minh (App Store với điện thoại iPhone) hoặc (Google Play với điện
                thoại Android) để tìm và cài ứng dụng: “On+ Trực tiếp bóng đá”. Nếu bạn đã cài sẵn ứng dụng này nhưng
                chưa phải phiên bản mới nhất, hãy cập nhật ứng dụng để được kích hoạt các tính năng mới.
              </span>
            </div>
            <br></br>
            <div className="leading-6 font-bold text-sm text-primary-300">
              Bước 2: Mở ứng dụng On+ và chọn xem trận đấu
              <span className="block font-normal leading-6 ">
                Nếu chưa đăng nhập, ứng dụng On+ sẽ yêu cầu bạn thực hiện đăng nhập để xem trận đấu phát trực tiếp. Hãy
                làm theo hướng dẫn của ứng dụng
              </span>
            </div>
            <br></br>
            <div className="w-full pl-[15%] pr-[15%]">
              <img src={" https://stvinaprod.vtvcab.vn/47a5084e-bab4-4675-9b52-295424db3576.png"} alt=""></img>
            </div>
            <br></br>
            <div className="leading-6 font-bold text-sm text-primary-300">
              Bước 3: Người chơi MiniGame cách chơi như sau
              <span className="block font-normal leading-6 ">
                - Các minigames sẽ hiện ra ở các phút thứ 5, 10, 20, 30, 40, 50, 55, 65, 75 và 85. Thời gian chơi mỗi
                minigame là 45 giây. Thời gian chơi được đếm ngược về 0. Người chơi lựa chọn câu trả lời và nhấn vào nút
                đóng trên màn hình.
              </span>
              <span className="block font-normal leading-6 ">
                - Nếu hết giờ nhưng người chơi không nhấn vào câu trả lời nào hoặc người chơi nhấn vào nút đóng thì được
                hiểu là người chơi bỏ qua minigame đó.
              </span>
              <span className="block font-normal leading-6 ">
                - Nếu người chơi chọn một câu trả lời và đợi hết giờ hoặc chọn xong và nhấn nút đóng thì câu trả lời đó
                sẽ được ghi nhận.
              </span>
              <span className="block font-normal leading-6 ">
                - Trong 45 giây, người chơi được phép đổi câu trả lời và lựa chọn cuối cùng sẽ được ghi nhận.
              </span>
              <span className="block font-normal leading-6 ">
                - Nếu trả lời đúng đáp án, người chơi sẽ được tích luỹ số điểm thiết lập sẵn cho minigame và tổng thời
                gian trả lời đáp án đúng sẽ được ghi nhận như hệ số phụ. Các câu trả lời sai sẽ không tính vào hệ số phụ
                này. Hệ số phụ cao hơn nếu tổng thời gian trả lời tính cho các câu trả lời đúng ít hơn.
              </span>
              <span className="block font-normal leading-6 ">
                - Điểm tích luỹ được được sắp xếp theo thứ tự từ cao xuống thấp để tính thứ hạng. Nếu có nhiều người
                cùng điểm tích luỹ sẽ xét tiếp đến hệ số phụ.
              </span>
            </div>
          </div>
        </div>
      </Loading>
    </div>
  )
}
